export const getAlignText = (value: number) =>
  value === 1 ? "center" : value === 2 ? "right" : "left";
